module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"chart-change":"Изменить тип графика"},"en":{"chart-change":"Change chart type"}}')
  delete Component.options._Ctor
}
